import React from 'react';
import classnames from 'classnames';
import SimpleReactLightbox, { useLightbox, SRLWrapper } from 'simple-react-lightbox';
import ChevronRight from 'components/assets/chevron-right.svg';
import { Caption } from 'components/media/Caption';

import s from './ProductImages.module.scss';

type Props = {
  children: React.ReactNode;
};

export const ProductImages = ({ children }: Props) => {
  return (
    <SimpleReactLightbox>
      <ProductImagesNested>{children}</ProductImagesNested>
    </SimpleReactLightbox>
  );
};

export const ProductImagesNested = ({ children }: Props) => {
  const { openLightbox, closeLightbox } = useLightbox();
  const [primary, setPrimary] = React.useState(0);
  const childCount = React.Children.toArray(children).length;

  const nextImage = () => {
    setPrimary(primary + 1 === childCount ? 0 : primary + 1);
  };

  const previousImage = () => {
    setPrimary(primary - 1 < 0 ? childCount - 1 : primary - 1);
  };

  const lightboxOptions = {
    settings: {
      disablePanzoom: true,
    },
    buttons: {
      showAutoplayButton: false,
      showDownloadButton: false,
      showFullscreenButton: false,
      showThumbnailsButton: false,
    },
  };

  const lightboxImages = [];

  React.Children.map(children, (component: any) => {
    lightboxImages.push({
      src: component?.props?.src,
      caption: component?.props?.alt,
    });
  });

  return (
    <aside className={s.productImages}>
      {React.Children.map(children[primary], (component: any) => (
        // <SRLWrapper elements={lightboxImages} options={options}>
        <figure className={s.productImages__hero}>
          {childCount > 1 && (
            <div className={s.productImages__controls}>
              <button className={s.productImages__previous} onClick={previousImage}>
                <ChevronRight />
              </button>
              <button className={s.productImages__next} onClick={nextImage}>
                <ChevronRight />
              </button>
            </div>
          )}
          <a className={s.productImages__link} onClick={() => openLightbox(primary)}>
            {React.cloneElement(component)}
          </a>
          {component?.props?.alt && (
            <Caption className={s.productImages__caption} caption={component.props.alt} />
          )}
        </figure>
        // </SRLWrapper>
      ))}
      {childCount > 1 && (
        <div className={s.productImages__grid}>
          {React.Children.map(children, (component: JSX.Element, i: number) => (
            <div
              className={classnames(s.productImages__image, { [s.active]: i === primary })}
              onClick={() => setPrimary(i)}
            >
              {React.cloneElement(component)}
            </div>
          ))}
        </div>
      )}
      <SRLWrapper elements={lightboxImages} options={lightboxOptions} />
    </aside>
  );
};
